import { render, staticRenderFns } from "./coal-match-result.vue?vue&type=template&id=139c9b60&scoped=true&"
import script from "./coal-match-result.vue?vue&type=script&lang=js&"
export * from "./coal-match-result.vue?vue&type=script&lang=js&"
import style0 from "./coal-match-result.vue?vue&type=style&index=0&id=139c9b60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139c9b60",
  null
  
)

export default component.exports